module.exports = __webpack_public_path__ + "img/gallery11.96d06292.jpg";